import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "clearfix" };
const _hoisted_3 = { class: "clearfix" };
const _hoisted_4 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_5 = { class: "input-group top_search" };
const _hoisted_6 = { class: "input-group-btn" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* HOISTED */);
const _hoisted_8 = [
    _hoisted_7
];
const _hoisted_9 = { class: "col-xs-12 col-sm-12 col-md-8" };
const _hoisted_10 = { class: "float-end" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-plus" }, null, -1 /* HOISTED */);
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Add File", -1 /* HOISTED */);
const _hoisted_13 = { class: "col-xs-12 col-sm-12" };
const _hoisted_14 = { class: "card bg-white data-grid company-detail-grid detached" };
const _hoisted_15 = { class: "table table-hover bottom0 pw100" };
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("th", { class: "text-center hidden-sm w40 no-min-width" }, null, -1 /* HOISTED */);
const _hoisted_17 = { class: "hidden-sm" };
const _hoisted_18 = { class: "hidden-sm" };
const _hoisted_19 = { class: "text-center hidden-sm" };
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-download" }, null, -1 /* HOISTED */);
const _hoisted_21 = { class: "hidden-sm" };
const _hoisted_22 = { class: "hidden-sm" };
const _hoisted_23 = { class: "hidden-sm" };
const _hoisted_24 = { key: 0 };
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("td", {
    class: "text-center",
    colspan: "6"
}, [
    /*#__PURE__*/ _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_26 = [
    _hoisted_25
];
const _hoisted_27 = { class: "data-grid-footer clearfix detached pw100" };
const _hoisted_28 = { class: "clearfix" };
const _hoisted_29 = { class: "x_panel" };
const _hoisted_30 = { class: "x_content" };
const _hoisted_31 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("label", null, "Site *", -1 /* HOISTED */);
const _hoisted_33 = { class: "input-group" };
const _hoisted_34 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_35 = /*#__PURE__*/ _createElementVNode("label", null, "System", -1 /* HOISTED */);
const _hoisted_36 = { class: "input-group" };
const _hoisted_37 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_38 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\tFile (*.key)\r\n\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_39 = { class: "float-end float-start-sm" };
const _hoisted_40 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* HOISTED */);
const _hoisted_41 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_button = _resolveComponent("b-button");
    const _component_SortableColumnComponent = _resolveComponent("SortableColumnComponent");
    const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
    const _component_b_dropdown = _resolveComponent("b-dropdown");
    const _component_b_button_group = _resolveComponent("b-button-group");
    const _component_b_pagination = _resolveComponent("b-pagination");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_container = _resolveComponent("b-container");
    const _component_b_modal = _resolveComponent("b-modal");
    const _component_StatusOverlayComponent = _resolveComponent("StatusOverlayComponent");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_b_form_input, {
                            type: "text",
                            modelValue: _ctx.query.keywords,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.query.keywords) = $event)),
                            modelModifiers: { trim: true },
                            placeholder: "Search for...",
                            onKeyup: _withKeys(_ctx.search, ["enter"]),
                            required: ""
                        }, null, 8 /* PROPS */, ["modelValue", "onKeyup"]),
                        _createTextVNode(),
                        _createElementVNode("span", _hoisted_6, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-default",
                                onClick: _cache[1] || (_cache[1] =
                                    //@ts-ignore
                                    (...args) => (_ctx.search && _ctx.search(...args)))
                            }, _hoisted_8)
                        ])
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_b_button, {
                            variant: "primary",
                            onClick: _ctx.add
                        }, {
                            default: _withCtx(() => [
                                _hoisted_11,
                                _hoisted_12
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"])
                    ])
                ])
            ]),
            _createTextVNode(),
            _withDirectives(_createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("table", _hoisted_15, [
                        _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _hoisted_16,
                                _createTextVNode(),
                                _createElementVNode("th", null, [
                                    _createVNode(_component_SortableColumnComponent, {
                                        sorter: _ctx.sorter,
                                        column: { fieldName: 'WhenCreated', title: 'Date/Time' }
                                    }, null, 8 /* PROPS */, ["sorter"])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("th", null, [
                                    _createVNode(_component_SortableColumnComponent, {
                                        sorter: _ctx.sorter,
                                        column: { fieldName: 'Site.SiteName', title: 'Site' }
                                    }, null, 8 /* PROPS */, ["sorter", "column"])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("th", null, [
                                    _createVNode(_component_SortableColumnComponent, {
                                        sorter: _ctx.sorter,
                                        column: { fieldName: 'System.SystemName', title: 'System' }
                                    }, null, 8 /* PROPS */, ["sorter", "column"])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("th", _hoisted_17, [
                                    _createVNode(_component_SortableColumnComponent, {
                                        sorter: _ctx.sorter,
                                        column: { fieldName: 'FileName', title: 'File Name' }
                                    }, null, 8 /* PROPS */, ["sorter"])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("th", _hoisted_18, [
                                    _createVNode(_component_SortableColumnComponent, {
                                        sorter: _ctx.sorter,
                                        column: { fieldName: 'UserName', title: 'Who Created' }
                                    }, null, 8 /* PROPS */, ["sorter"])
                                ])
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                    class: _normalizeClass({ 'deleted': item.whenDeleted })
                                }, [
                                    _createElementVNode("td", _hoisted_19, [
                                        _createVNode(_component_b_button_group, null, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_b_dropdown, {
                                                    variant: "outline-secondary dots",
                                                    size: "sm",
                                                    onClick: ($event) => (_ctx.downloadFile(item))
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_b_dropdown_item, {
                                                            onClick: ($event) => (_ctx.downloadFile(item))
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _hoisted_20,
                                                                _createTextVNode(" Download File\r\n\t\t\t\t\t\t\t\t\t\t\t")
                                                            ]),
                                                            _: 2 /* DYNAMIC */
                                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                            ]),
                                            _: 2 /* DYNAMIC */
                                        }, 1024 /* DYNAMIC_SLOTS */)
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("td", null, _toDisplayString(_ctx.getDateTimeFormatted(item.whenCreated)), 1 /* TEXT */),
                                    _createTextVNode(),
                                    _createElementVNode("td", null, _toDisplayString(item.siteName), 1 /* TEXT */),
                                    _createTextVNode(),
                                    _createElementVNode("td", _hoisted_21, _toDisplayString(item.systemName), 1 /* TEXT */),
                                    _createTextVNode(),
                                    _createElementVNode("td", _hoisted_22, _toDisplayString(item.fileName), 1 /* TEXT */),
                                    _createTextVNode(),
                                    _createElementVNode("td", _hoisted_23, _toDisplayString(item.userName), 1 /* TEXT */)
                                ], 2 /* CLASS */));
                            }), 256 /* UNKEYED_FRAGMENT */))
                        ]),
                        _createTextVNode(),
                        _createElementVNode("tfoot", null, [
                            (_ctx.noData)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_24, _hoisted_26))
                                : _createCommentVNode("v-if", true)
                        ])
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_b_pagination, {
                        class: "float-end",
                        modelValue: _ctx.query.pageNo,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.query.pageNo) = $event)),
                        "per-page": _ctx.query.pageSize,
                        "total-rows": _ctx.data.recordCount,
                        "hide-ellipsis": true,
                        disabled: _ctx.working
                    }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                ])
            ], 512 /* NEED_PATCH */), [
                [_vShow, _ctx.searchAttempted]
            ])
        ]),
        _createTextVNode(),
        _createVNode(_component_b_modal, {
            id: "data-collector-register-modal",
            modelValue: _ctx.showRegisterModal,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.showRegisterModal) = $event)),
            "header-bg-variant": "normal",
            size: "lg"
        }, {
            title: _withCtx(() => [
                _createTextVNode("\r\n\t\t\t\tAdd new identification file\r\n\t\t\t")
            ]),
            footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_39, [
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "primary",
                        onClick: _ctx.save,
                        disabled: _ctx.saveButtonDisabled
                    }, {
                        default: _withCtx(() => [
                            _hoisted_40,
                            _createTextVNode(" Save\r\n\t\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick", "disabled"]),
                    _createTextVNode(),
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "secondary",
                        onClick: _ctx.cancel
                    }, {
                        default: _withCtx(() => [
                            _hoisted_41,
                            _createTextVNode(" Cancel\r\n\t\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                ])
            ]),
            default: _withCtx(() => [
                _createTextVNode(),
                _createVNode(_component_b_container, { clearfix: "" }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("div", _hoisted_30, [
                                    _createElementVNode("div", _hoisted_31, [
                                        _hoisted_32,
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_33, [
                                            _createVNode(_component_multiselect, {
                                                modelValue: _ctx.siteId,
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.siteId) = $event)),
                                                options: _ctx.sites,
                                                "track-by": "value",
                                                label: "text",
                                                showLabels: false,
                                                placeholder: "Select a site",
                                                class: "multiselect-small"
                                            }, {
                                                noResult: _withCtx(() => [
                                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t")
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["modelValue", "options"])
                                        ])
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_34, [
                                        _hoisted_35,
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_36, [
                                            _createVNode(_component_multiselect, {
                                                modelValue: _ctx.systemId,
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.systemId) = $event)),
                                                options: _ctx.systems,
                                                "track-by": "value",
                                                label: "text",
                                                showLabels: false,
                                                placeholder: "Select a system",
                                                class: "multiselect-small"
                                            }, {
                                                noResult: _withCtx(() => [
                                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t")
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["modelValue", "options"])
                                        ])
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_37, [
                                        _hoisted_38,
                                        _createTextVNode(),
                                        _createElementVNode("input", {
                                            ref: "fileInput",
                                            class: "form-control",
                                            type: "file",
                                            name: "fileInput",
                                            accept: ".key",
                                            onChange: _cache[5] || (_cache[5] =
                                                //@ts-ignore
                                                (...args) => (_ctx.fileChanged && _ctx.fileChanged(...args)))
                                        }, null, 544 /* NEED_HYDRATION, NEED_PATCH */)
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _: 1 /* STABLE */
                }),
                _createTextVNode()
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"]),
        _createTextVNode(),
        _createVNode(_component_StatusOverlayComponent, {
            visible: _ctx.working,
            message: "Loading..."
        }, null, 8 /* PROPS */, ["visible"])
    ]));
}
